export const STATUSES = [
  { title: "Ready", type: "ready", color: "#409EFF" },
  { title: "Testing", type: "testing", color: "#67C23A" },
  { title: "Done", type: "done", color: "#C7C9CC" },
];

export const STATUSES_FILTER = [{ title: "All", type: "all" }, ...STATUSES];
